/**
 * Shipping Calculator — single-page, all carriers, searchable country, volumetric weight
 * Version: 5.1.0
 */
(function () {
  'use strict';

  var CARRIERS = [
    { key: 'KPACKET',   label: 'K-Packet',      time: '3–6 weeks',  maxKg: 2  },
    { key: 'EMS',       label: 'EMS Express',    time: '1–2 weeks',  maxKg: 30 },
    { key: 'FEDEX',     label: 'FedEx Priority', time: '5–10 days',  maxKg: 30 },
    { key: 'DHL',       label: 'DHL Express',    time: '3–5 days',   maxKg: 30 },
    // YunExpress: 요율표(DB)가 아니라 실시간 API. 아래 계산 루프에서 전용 엔드포인트로 분기 호출.
    { key: 'YUNEXPRESS', label: 'YunExpress',    time: '5–12 days',  maxKg: 30 }
  ];

  function apiBase() {
    return (window.API_BASE_URL || 'https://hallyu4u.api.hallyu-manager.com').replace(/\/$/, '');
  }

  // countryMap[countryEn] = { countryCode, carriers: Set<string> }
  var countryMap = {};
  var allCountries = [];   // sorted [{name, code}]
  var countriesLoaded = false;

  // ── Init ───────────────────────────────────────────────────────────────────

  function init() {
    var weightInput  = document.getElementById('sc-weight');
    var unitSelect   = document.getElementById('sc-unit');
    var lengthInput  = document.getElementById('sc-length');
    var widthInput   = document.getElementById('sc-width');
    var heightInput  = document.getElementById('sc-height');
    var volBadge     = document.getElementById('sc-vol-badge');
    var volValue     = document.getElementById('sc-vol-value');
    var calcBtn      = document.getElementById('sc-calculate');
    var loadingEl    = document.getElementById('sc-country-loading');

    if (!calcBtn) return;

    // ── Searchable dropdown ─────────────────────────────────────────────────
    var searchInput   = document.getElementById('sc-country-input');
    var countryHidden = document.getElementById('sc-country-value');
    var dropdown      = document.getElementById('sc-dropdown');
    var searchable    = document.getElementById('sc-searchable');

    var selectedCountry = '';  // currently selected countryEn

    function renderDropdown(filter) {
      filter = (filter || '').toLowerCase().trim();
      var list = filter
        ? allCountries.filter(function (c) { return c.name.toLowerCase().indexOf(filter) !== -1; })
        : allCountries;

      if (!list.length) {
        dropdown.innerHTML = '<div class="sc-dropdown-empty">No results</div>';
        return;
      }

      dropdown.innerHTML = list.map(function (c) {
        var hl = filter
          ? escHtml(c.name).replace(
              new RegExp('(' + escRegex(escHtml(filter)) + ')', 'gi'),
              '<mark>$1</mark>'
            )
          : escHtml(c.name);
        return '<div class="sc-dropdown-item" role="option" data-value="' + escHtml(c.name) + '">'
          + hl
          + (c.code ? ' <span class="sc-dropdown-code">' + escHtml(c.code) + '</span>' : '')
          + '</div>';
      }).join('');
    }

    function openDropdown() {
      renderDropdown(searchInput.value);
      dropdown.style.display = 'block';
      searchable.classList.add('sc-searchable--open');
    }

    function closeDropdown() {
      dropdown.style.display = 'none';
      searchable.classList.remove('sc-searchable--open');
      // restore display name if something is selected, else clear
      if (selectedCountry) {
        searchInput.value = selectedCountry;
      } else {
        searchInput.value = '';
      }
    }

    function selectCountry(name) {
      selectedCountry = name;
      countryHidden.value = name;
      searchInput.value = name;
      closeDropdown();
      updateBtn();
    }

    searchInput.addEventListener('focus', function () {
      searchInput.value = '';
      openDropdown();
    });

    searchInput.addEventListener('input', function () {
      renderDropdown(searchInput.value);
      if (dropdown.style.display === 'none') openDropdown();
      // clear selection if user changed the text
      selectedCountry = '';
      countryHidden.value = '';
      updateBtn();
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDropdown(); searchInput.blur(); }
    });

    dropdown.addEventListener('mousedown', function (e) {
      var item = e.target.closest('.sc-dropdown-item');
      if (item) {
        e.preventDefault();
        selectCountry(item.dataset.value);
      }
    });

    document.addEventListener('mousedown', function (e) {
      if (!searchable.contains(e.target)) closeDropdown();
    });

    // ── Volumetric weight ───────────────────────────────────────────────────

    function getVolWeight() {
      var l = parseFloat(lengthInput ? lengthInput.value : '');
      var w = parseFloat(widthInput  ? widthInput.value  : '');
      var h = parseFloat(heightInput ? heightInput.value : '');
      if (!isNaN(l) && !isNaN(w) && !isNaN(h) && l > 0 && w > 0 && h > 0) {
        return (l * w * h) / 5000;
      }
      return null;
    }

    function updateVolBadge() {
      var vol = getVolWeight();
      if (vol !== null && volBadge && volValue) {
        volValue.textContent = vol.toFixed(3);
        volBadge.style.display = 'flex';
      } else if (volBadge) {
        volBadge.style.display = 'none';
      }
      updateBtn();
    }

    if (lengthInput) lengthInput.addEventListener('input', updateVolBadge);
    if (widthInput)  widthInput.addEventListener('input',  updateVolBadge);
    if (heightInput) heightInput.addEventListener('input', updateVolBadge);

    // ── Actual weight / unit ────────────────────────────────────────────────

    function getActualWeightKg() {
      var raw  = parseFloat(weightInput ? weightInput.value : '');
      var unit = unitSelect ? unitSelect.value : 'kg';
      if (isNaN(raw) || raw <= 0) return null;
      if (unit === 'g')  return raw / 1000;
      if (unit === 'lb') return raw * 0.453592;
      return raw;
    }

    function getChargeableWeightKg() {
      var actual = getActualWeightKg();
      var vol    = getVolWeight();
      if (actual === null) return null;
      return vol !== null ? Math.max(actual, vol) : actual;
    }

    if (weightInput) weightInput.addEventListener('input', updateBtn);
    if (unitSelect)  unitSelect.addEventListener('change', updateBtn);

    function updateBtn() {
      calcBtn.disabled = !countriesLoaded || !selectedCountry || getChargeableWeightKg() === null;
    }

    // ── Calculate click ─────────────────────────────────────────────────────

    calcBtn.addEventListener('click', function () {
      var country = selectedCountry;
      var kg      = getChargeableWeightKg();
      var actual  = getActualWeightKg();
      var vol     = getVolWeight();
      if (!country || kg === null) return;
      calculate(country, kg, actual, vol);
    });

    // ── Load countries ──────────────────────────────────────────────────────

    if (loadingEl) loadingEl.style.display = 'flex';

    // YunExpress 는 요율표(DB) 캐리어가 아니라 /countries 가 없으므로 국가목록 로딩에서 제외한다.
    // (국가 후보는 DB 캐리어 합집합을 사용하고, YunExpress 카드는 그 국가들에 대해 실시간 견적)
    Promise.all(CARRIERS.filter(function (c) { return c.key !== 'YUNEXPRESS'; }).map(function (c) {
      return fetch(apiBase() + '/api/shipping-rates/' + c.key + '/countries')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          if (!json || !json.data || !json.data.countries) return;
          json.data.countries.forEach(function (item) {
            if (!countryMap[item.countryEn]) {
              countryMap[item.countryEn] = { countryCode: item.countryCode || '', carriers: new Set() };
            }
            countryMap[item.countryEn].carriers.add(c.key);
          });
        })
        .catch(function () {});
    })).then(function () {
      if (loadingEl) loadingEl.style.display = 'none';
      countriesLoaded = true;

      allCountries = Object.keys(countryMap).sort().map(function (name) {
        return { name: name, code: countryMap[name].countryCode };
      });

      searchInput.disabled = false;
      searchInput.placeholder = 'Search country…';
      updateBtn();
    });

    // Disable input until countries are loaded
    searchInput.disabled = true;
    searchInput.placeholder = 'Loading…';
  }

  // ── Calculate ──────────────────────────────────────────────────────────────

  function calculate(countryEn, chargeableKg, actualKg, volKg) {
    var btn        = document.getElementById('sc-calculate');
    var btnText    = btn ? btn.querySelector('.sc-btn-text')    : null;
    var btnSpin    = btn ? btn.querySelector('.sc-btn-spinner') : null;
    var resultsEl  = document.getElementById('sc-results');
    var metaEl     = document.getElementById('sc-results-meta');
    var carriersEl = document.getElementById('sc-carriers');

    if (btn)     btn.disabled = true;
    if (btnText) btnText.style.display = 'none';
    if (btnSpin) btnSpin.style.display = 'inline-block';

    if (resultsEl)  resultsEl.style.display  = 'block';
    if (carriersEl) carriersEl.innerHTML     = CARRIERS.map(skeletonCard).join('');
    if (metaEl)     metaEl.innerHTML         = buildMeta(countryEn, chargeableKg, actualKg, volKg);

    var promises = CARRIERS.map(function (c) {
      // ── YunExpress: 실시간 API 전용 분기 ──────────────────────────────────
      // DB 취급국가 목록에 없으니 "not served" 사전체크는 건너뛰고, 백엔드 견적 결과로 판정.
      if (c.key === 'YUNEXPRESS') {
        if (chargeableKg > c.maxKg) {
          return Promise.resolve({ carrier: c, status: 'overweight', maxKg: c.maxKg });
        }
        var ccode = (countryMap[countryEn] && countryMap[countryEn].countryCode) || '';
        return fetch(apiBase() + '/api/shipping-rates/yunexpress/quote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            countryEn:   countryEn,
            countryCode: ccode,
            weightKg:    parseFloat(chargeableKg.toFixed(3))
          })
        })
          .then(function (r) { return r.json().then(function (j) { return { r: r, j: j }; }); })
          .then(function (o) {
            if (!o.r.ok) return { carrier: c, status: 'error', message: (o.j && o.j.message) || 'Error' };
            var d = o.j && o.j.data;
            if (!d || d.available === false || d.priceKrw == null) {
              return { carrier: c, status: 'unavailable' };
            }
            return { carrier: c, status: 'ok', data: { priceKrw: d.priceKrw } };
          })
          .catch(function () { return { carrier: c, status: 'error', message: 'Network error' }; });
      }

      // not served
      if (countryMap[countryEn] && !countryMap[countryEn].carriers.has(c.key)) {
        return Promise.resolve({ carrier: c, status: 'unavailable' });
      }
      // overweight
      if (chargeableKg > c.maxKg) {
        return Promise.resolve({ carrier: c, status: 'overweight', maxKg: c.maxKg });
      }

      return fetch(apiBase() + '/api/shipping-rates/calculate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          carrier:   c.key,
          countryEn: countryEn,
          weightKg:  parseFloat(chargeableKg.toFixed(3))
        })
      })
        .then(function (r) { return r.json().then(function (j) { return { r: r, j: j }; }); })
        .then(function (o) {
          if (!o.r.ok) return { carrier: c, status: 'error', message: (o.j && o.j.message) || 'Error' };
          return { carrier: c, status: 'ok', data: o.j.data };
        })
        .catch(function () { return { carrier: c, status: 'error', message: 'Network error' }; });
    });

    Promise.all(promises).then(function (results) {
      if (carriersEl) carriersEl.innerHTML = results.map(renderCarrierCard).join('');
      if (btn)     btn.disabled = false;
      if (btnText) btnText.style.display = '';
      if (btnSpin) btnSpin.style.display = 'none';
      if (resultsEl) resultsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  // ── Render helpers ─────────────────────────────────────────────────────────

  function buildMeta(countryEn, chargeableKg, actualKg, volKg) {
    var weightLabel = chargeableKg.toFixed(3) + ' kg';
    var tag = '';
    if (volKg !== null) {
      if (volKg > actualKg) {
        tag = '<span class="sc-meta-tag sc-meta-tag--vol">volumetric</span>';
      } else {
        tag = '<span class="sc-meta-tag sc-meta-tag--actual">actual</span>';
      }
    }

    return '<span class="sc-meta-item">'
      + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="10" r="3"/><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/></svg>'
      + escHtml(countryEn)
      + '</span>'
      + '<span class="sc-meta-sep">·</span>'
      + '<span class="sc-meta-item">'
      + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="6" width="14" height="10" rx="2"/></svg>'
      + weightLabel
      + tag
      + '</span>';
  }

  function skeletonCard(c) {
    return '<div class="sc-carrier-card sc-carrier-card--loading" data-carrier="' + c.key + '">'
      + '<div class="sc-carrier-name">' + escHtml(c.label) + '</div>'
      + '<div class="sc-carrier-time">' + escHtml(c.time) + '</div>'
      + '<div class="sc-carrier-price-skeleton"></div>'
      + '</div>';
  }

  function renderCarrierCard(result) {
    var c      = result.carrier;
    var status = result.status;
    var cls    = 'sc-carrier-card';
    if (status === 'ok')          cls += ' sc-carrier-card--ok';
    if (status === 'unavailable' || status === 'overweight') cls += ' sc-carrier-card--na';
    if (status === 'error')       cls += ' sc-carrier-card--error';

    var html = '<div class="' + cls + '" data-carrier="' + c.key + '">'
             + '<div class="sc-carrier-header">'
             +   '<div class="sc-carrier-name">' + escHtml(c.label) + '</div>'
             +   '<div class="sc-carrier-time">' + escHtml(c.time) + '</div>'
             + '</div>';

    if (status === 'ok') {
      var s    = window.shippingCalculatorSettings || {};
      var krw  = result.data.priceKrw;
      var usd  = (krw / (s.usd_rate || 1400)).toFixed(2);
      var eur  = (krw / (s.eur_rate || 1500)).toFixed(2);
      var gbp  = (krw / (s.gbp_rate || 1700)).toFixed(2);

      html += '<div class="sc-carrier-price">'
            +   '<span class="sc-price-krw">₩' + krw.toLocaleString() + '</span>'
            + '</div>'
            + '<div class="sc-carrier-conversions">'
            +   '<span>$' + usd + '</span>'
            +   '<span>€' + eur + '</span>'
            +   '<span>£' + gbp + '</span>'
            + '</div>';
    } else if (status === 'overweight') {
      html += naBlock('Exceeds max ' + c.maxKg + 'kg');
    } else if (status === 'unavailable') {
      html += naBlock('Not available');
    } else {
      html += naBlock('Unavailable');
    }

    return html + '</div>';
  }

  function naBlock(msg) {
    return '<div class="sc-carrier-na">'
      + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>'
      + '<span>' + escHtml(msg) + '</span>'
      + '</div>';
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // ── Bootstrap ──────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
